'use client'
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { InputButton } from "../../InputButton/index.js";
import { Footer } from "../CustomComponents/Footer.js";
import { getFormattedDates } from "../helpers/helpers.js";
import { DatePickerDesktop } from "../DatePickerDesktop/DatePickerDesktop.js";
import { OverlayCalendar } from "../OverlayCalendar/OverlayCalendar.js";
const DEFAULT_DATE_PICKER_FORMAT = 'ccc, MMM d';
function DatePicker({ mode = 'single', handleCalendarChange, footerLeftNode, subHeading, components: initialComponents, label, selected, displayNights, isMobile, isOpen: isCalendarOpen = false, placeholder, isDisabled, errorMessage, helperText, errorText, ...restProps }) {
    const [isOpen, setIsOpen] = useState(isCalendarOpen);
    let initialFormattedDates = subHeading ?? '';
    if (selected && !subHeading) initialFormattedDates = getFormattedDates({
        dates: selected,
        dateFormat: DEFAULT_DATE_PICKER_FORMAT,
        displayNights
    });
    const [formattedDates, setFormattedDates] = useState(initialFormattedDates);
    const [selectedDates, setSelectedDates] = useState(selected);
    const handleCalendarDates = useCallback((newDates)=>{
        if (!subHeading) setFormattedDates(getFormattedDates({
            dates: newDates,
            dateFormat: DEFAULT_DATE_PICKER_FORMAT,
            displayNights
        }));
        setSelectedDates(newDates);
        handleCalendarChange(newDates);
    }, [
        handleCalendarChange,
        subHeading,
        displayNights
    ]);
    const handleCalendarDisplayState = useCallback((val)=>{
        setIsOpen(val);
    }, []);
    const handleOpen = useCallback(()=>{
        setIsOpen(true);
    }, []);
    const value = subHeading || formattedDates || '';
    const subHeadingValue = subHeading || formattedDates || label || '';
    const renderInput = useCallback((props)=>/*#__PURE__*/ jsx("div", {
            "data-testid": "date-picker-input",
            ...props,
            children: /*#__PURE__*/ jsx(InputButton, {
                className: "w-full",
                label: label,
                value: value,
                iconLeft: 'calendar_month',
                size: 'lg',
                placeholder: placeholder,
                isDisabled: isDisabled,
                errorMessage: errorMessage,
                helperText: helperText,
                errorText: errorText
            })
        }), [
        errorMessage,
        errorText,
        helperText,
        isDisabled,
        label,
        placeholder,
        value
    ]);
    const components = {
        ...initialComponents,
        Footer: ()=>/*#__PURE__*/ jsx(Footer, {
                footerLeftNode: footerLeftNode,
                handleFooterCallBack: handleCalendarDisplayState
            })
    };
    if (isMobile) return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            renderInput({
                onClick: handleOpen
            }),
            /*#__PURE__*/ jsx(OverlayCalendar, {
                mode: mode,
                handleCalendarChange: handleCalendarDates,
                open: isOpen,
                handleDrawerState: handleCalendarDisplayState,
                selected: selectedDates,
                subHeading: subHeadingValue,
                ...restProps
            })
        ]
    });
    return /*#__PURE__*/ jsx(DatePickerDesktop, {
        mode: mode,
        open: isOpen,
        handlePopOverOpenState: handleCalendarDisplayState,
        inputNode: renderInput,
        title: label,
        selected: selectedDates,
        handleCalendarChange: handleCalendarDates,
        components: components,
        ...restProps
    });
}
export { DEFAULT_DATE_PICKER_FORMAT, DatePicker };
